export const UPDATE_PLACE = 'UPDATE_PLACE';
export const UPDATE_PLACE_DETAILS_IDS = 'UPDATE_PLACE_DETAILS_IDS';
export const ADD_PLACE_DETAILS_IDS = 'ADD_PLACE_DETAILS_IDS';
export const PLACE_DETAIL_ID_REMOVE = 'PLACE_DETAIL_ID_REMOVE';
export const PLACE_FETCHED = 'PLACE_FETCHED';
export const PLACE_REVIEW_TIME_STATS_FETCHED = 'PLACE_REVIEW_TIME_STATS_FETCHED';
export const PLACE_REVIEW_VOTE_STATS_FETCHED = 'PLACE_REVIEW_VOTE_STATS_FETCHED';
export const PLACE_CLEAR = 'PLACE_CLEAR';
